import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { CurrencyPipe } from "@angular/common";
import { UsatiService } from "./services/usati.service";
import {
  NgxGalleryAnimation,
  NgxGalleryImage,
  NgxGalleryImageSize,
  NgxGalleryOptions,
} from "@kolkov/ngx-gallery";
import * as moment from "moment";
import { format } from "date-fns";

@Component({
  selector: "app-usati",
  templateUrl: "./usati.component.html",
  styleUrls: ["./usati.component.scss"],
})
export class UsatiComponent implements OnInit, OnDestroy {
  form: FormGroup;
  url = "usati/";

  id: number;

  pratica: any = {};

  loggato: boolean;

  galleryOptions: NgxGalleryOptions[] = [];
  galleryImages: NgxGalleryImage[] = [];

  newVariable: any;

  constructor(
    private route: ActivatedRoute,
    private service: UsatiService,
    private router: Router,
    private http: HttpClient,
    private currencyPipe: CurrencyPipe,
  ) {}

  async ngOnInit(): Promise<void> {
    if (this.route.snapshot.params.id === "usati") {
      this.router.navigate(["/usati"]);
    }

    this.newVariable = window.navigator;

    this.id = this.route.snapshot.params.id;
    console.log("Received ID:", this.id);
    this.form = this.service.creaFormGroup();
    this.loggato =
      localStorage.getItem("orion-usati-password") &&
      localStorage.getItem("orion-usati-password") === "1"
        ? true
        : false;

    this.galleryOptions = [
      {
        width: "100%",
        height: "1000px",
        thumbnailsColumns: 4,
        imageAnimation: NgxGalleryAnimation.Slide,
        imageSize: NgxGalleryImageSize.Contain,
      },
      // max-width 800
      {
        breakpoint: 800,
        width: "100%",
        height: "800px",
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 20,
      },
      // max-width 400
      {
        height: "300px",
        breakpoint: 400,
        preview: false,
        lazyLoading: false,
      },
    ];

    const result = await this.service
      .ricerca<any>(`veicolo/${this.id}/web/singola/`, {
        loggato: this.loggato,
      })
      .toPromise();

    this.pratica = result.data;

    if (this.pratica.accessori) {
      this.pratica.accessoriVeicolo = this.pratica.accessori.filter((acc) => {
        return acc.prvTipo === 2;
      });
      this.pratica.accessoriAllestimento = this.pratica.accessori.filter(
        (acc) => {
          return acc.prvTipo === 3;
        },
      );
    }

    localStorage.setItem(
      "orion-usati-pratica",
      this.pratica.vclPratica.toString(),
    );

    if (this.pratica.foto && this.pratica.foto.length > 0) {
      this.pratica.foto.sort((a, b) => {
        if (a.index > b.index) {
          return 1;
        }
        if (b.index > a.index) {
          return -1;
        }

        return 0;
      });

      for (let i = 0, len = this.pratica.foto.length; i < len; i++) {
        const f = this.pratica.foto[i];

        const result1 = await this.service
          .getImage(`veicolo/${this.pratica.IDvcl}/web/download/immagine/`,
            f.nomeFileFoto,
          )
          .toPromise();
        if (result1) {
          const file = new Blob([result1], { type: "application/jpg" }),
            fileURL = window.URL.createObjectURL(file);

          this.galleryImages.push({
            small: fileURL,
            medium: fileURL,
            big: fileURL,
          });
        }
      }
    } else {
      const result1 = await this.service
        .getImage("veicolo/xxx/web/download/immagine/", "")
        .toPromise();

      if (result1) {
        const file = new Blob([result1], { type: "application/jpg" }),
          fileURL = window.URL.createObjectURL(file);

        this.galleryImages.push({
          small: fileURL,
          medium: fileURL,
          big: fileURL,
        });
      }
    }

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  stampa() {
    this.service
      .stampa("veicolo/" + this.pratica.IDvcl + "/web/stampa/scheda/usato")
      .subscribe(
        (result1) => {
          const file = new Blob([result1], { type: "application/pdf" }),
            fileURL = window.URL.createObjectURL(file);

          window.open(fileURL, "_blank");
        },
        (error) => {
          console.log(error);
        },
      );
  }

  share() {
    if (this.newVariable && this.newVariable.share) {
      console.log(
        "DEBUG",
        moment(this.pratica.vclDataImmatr).format("DD/MM/YYYY"),
        format(new Date(this.pratica.vclDataImmatr), "DD/MM/YYYY"),
      );

      this.newVariable
        .share({
          title: "Pratica " + this.pratica.vclPratica,
          text: `${this.pratica.vclTipologia} ${
            this.pratica.vclcntVclTipo
          } Anno: ${moment(this.pratica.vclDataImmatr).format(
            "DD/MM/YYYY",
          )} ${format(new Date(this.pratica.vclDataImmatr), "DD/MM/YYYY")}`,
          url:
            "https://www.ambulanzeusate.it/usati/veicolo-usato/" +
            this.pratica.vclPratica,
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    } else {
      console.log("share not supported");
    }
  }

  ngOnDestroy() {
    localStorage.setItem("orion-usati-pratica", "");
  }
}
